// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

export const DEFAULT_LANDING = "/evolution-cycles"

// A `null` answer means the destination could send the browser off-origin;
// the caller falls back to `DEFAULT_LANDING`.
export const safeReturnTo = (candidate: unknown): string | null => {
  if (typeof candidate !== "string") return null
  // The front page is a protected route of its own, and its lone slash
  // leaves nothing for the authority check below to look at.
  if (candidate === "/") return candidate
  // A second leading slash or backslash starts an authority — browsers
  // read `//evil.test` and `/\evil.test` as another origin.
  if (!/^\/[^/\\]/.test(candidate)) return null
  return candidate
}

// The OAuth round trip leaves the origin, so router state cannot carry the
// destination across it. A same-origin path is not a credential, which is
// why this handover may use storage the session itself never may.
const CARRIER_KEY = "ebiose.returnTo"

export const rememberReturnTo = (destination: string): void => {
  const safe = safeReturnTo(destination)
  if (safe) sessionStorage.setItem(CARRIER_KEY, safe)
}

// Single use: reading the destination also clears the carrier.
export const takeReturnTo = (): string | null => {
  const stored = sessionStorage.getItem(CARRIER_KEY)
  sessionStorage.removeItem(CARRIER_KEY)
  return safeReturnTo(stored)
}
